import { useNavigate } from "react-router-dom";
import CertificadoFormCadastro from "../../../Components/Populados/Pessoa/Empresa/Certificado/CertificadoFormCadastro";

export default function Cadastro() {
    const navigate = useNavigate();
    return <CertificadoFormCadastro
        onCancelar={(ev) => navigate(-1)}
        onSalvarSucesso={(ev) => navigate(-1)}
    />;
}